import { render } from "./PoolV2.htm?vue&type=template&id=210e6ea5&scoped=true"
import script from "./PoolV2.js?vue&type=script&lang=js"
export * from "./PoolV2.js?vue&type=script&lang=js"

import "./PoolV2.scss?vue&type=style&index=0&id=210e6ea5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210e6ea5"]])

export default __exports__